// @flow
import React from 'react';
import { connect } from 'react-redux';
import { Grid, Row, Col } from 'react-flexbox-grid';
import {
  MdClose,
  MdSearch,
} from 'react-icons/lib/md';
import {
  reduxForm,
  Field,
} from 'redux-form';
import i18n from 'i18n-js';

import * as selectors from '../../../reducers';
import { OMNISEARCH_RESULT_TYPES } from '../../Omnisearch';
import {
  onSubmit,
  validate,
} from './utils';
import PopupHeader from '../../PopupHeader';
import PopupHeaderRightGroup from '../../PopupHeaderRightGroup';
import PopupHeaderLeftGroup from '../../PopupHeaderLeftGroup';
import PopupContent from '../../PopupContent';
import PopupFooter from '../../PopupFooter';
import PopupHeaderTitle from '../../PopupHeaderTitle';
import Button from '../../Button';
import PopupCloseButton from '../../PopupCloseButton';
import {
  RenderInput,
  RenderTypeahead,
  RenderToggleSwitch,
} from '../../FieldRenderer';
import OmnisearchLoadingResults from '../../OmnisearchLoadingResults';
import OmnisearchResult from '../../OmnisearchResult';
import { generateFetcher } from '../../Omnisearch/utils';
import CloseableInputSearchResult from '../../CloseableInputSearchResult';
import SwitchLabel from '../../SwitchLabel';

import { Cancel, CreateButton, Boolean, Search } from '../../CommonTexts';
import styles from './createExitMethodPopupForm.css';


type CreateExitMethodPopupFormPropTypes = {
  handleSubmit: Function,
  fetchPuertas: string => Promise<Array<Object>>,
};

const customRenderSelected = (item, onClear) => {
  switch (item.result_type) {
    case OMNISEARCH_RESULT_TYPES.gate: {
      return (
        <CloseableInputSearchResult
          title={item.name}
          subtitle={item.code}
          closeAction={onClear}
        />
      );
    }
    default: return null;
  }
};

const customRenderItem = (item: Object, isHighlighted: boolean) => (
  <OmnisearchResult
    {...item}
    isSelected={isHighlighted}
    size="small"
  />
);

const CreateExitMethodPopupForm = ({
  handleSubmit,
  fetchPuertas,
}: CreateExitMethodPopupFormPropTypes) => (
  <form id="createRoute" onSubmit={handleSubmit}>
    <PopupHeader size="big">
      <PopupHeaderLeftGroup>
        <PopupHeaderTitle title={CreateButton(i18n.t('common.gateway', { count: 1 }))} size="big" />
      </PopupHeaderLeftGroup>
      <PopupHeaderRightGroup>
        <PopupCloseButton
          size="medium"
          Icon={MdClose}
          tint="mediumGray"
          clearMargins
          isTransparent
          isOutlined
        />
      </PopupHeaderRightGroup>
    </PopupHeader>
    <PopupContent className={styles.createExitMethodPopupContent} size="large">
      <Grid>
        <Row>
          <Col xs={7}>
            <Field
              name="name"
              label={i18n.t('labels.name', { count: 1 })}
              placeholder="ie. Puerta 2, Fuente"
              component={RenderInput}
              type="text"
              autoFocus
            />
          </Col>
          <Col xs={2} xsOffset={1}>
            <SwitchLabel
              text={i18n.t('gateways.creatingGateway')}
              fontSize="medium"
            />
          </Col>
          <Col xs={2}>
            <Field
              name="ordinal"
              label="&nbsp;"
              placeholder="01"
              component={RenderInput}
              type="text"
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Field
              name="gate"
              label={i18n.t('common.gate', { count: 1 })}
              component={RenderTypeahead}
              inputDebounce={200}
              renderSelectedValue={customRenderSelected}
              renderLoading={() => <OmnisearchLoadingResults size="small" count={3} />}
              fetchItems={fetchPuertas}
              renderItem={customRenderItem}
              inputProps={{
                Icon: MdSearch,
                iconPosition: 'right',
                placeholder: Search(i18n.t('common.gate', { count: 1 }), 1),
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <br />
            <br />
          </Col>
        </Row>
        <Row>
          <Col xs={2} xsOffset={2}>
            <SwitchLabel
              text={i18n.t('labels.allowsExit')}
              fontSize="medium"
            />
          </Col>
          <Col xs={2}>
            <Field
              name="allow_exit"
              component={RenderToggleSwitch}
              trueTitle={Boolean(true)}
              falseTitle={Boolean(false)}
              value
            />
          </Col>
          <Col xs={2}>
            <SwitchLabel
              text={i18n.t('labels.allowsEntry')}
              fontSize="medium"
            />
          </Col>
          <Col xs={2}>
            <Field
              name="allow_entrance"
              component={RenderToggleSwitch}
              trueTitle={Boolean(true)}
              falseTitle={Boolean(false)}
              value
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <br />
            <br />
            <br />
            <hr />
            <br />
            <br />
            <br />
          </Col>
        </Row>
        <Row>
          <Col xsOffset={3} xs={3}>
            <SwitchLabel
              text={i18n.t('labels.allowsChangeRequests')}
              fontSize="medium"
            />
          </Col>
          <Col xs={3}>
            <Field
              name="allow_change_requests"
              component={RenderToggleSwitch}
              trueTitle={Boolean(true)}
              falseTitle={Boolean(false)}
            />
          </Col>
        </Row>
      </Grid>
    </PopupContent>
    <PopupFooter size="large">
      <PopupCloseButton title={Cancel()} tint="paleGray" />
      <Button type="submit" title={CreateButton(i18n.t('common.gateway', { count: 1 }))} />
    </PopupFooter>
  </form>
);

export default connect(
  (state) => {
    const schoolId = (selectors.getProfileOfType(state, 'admin') || {}).school || -1;
    const token = selectors.getToken(state);

    const fetchPuertas = generateFetcher(
      OMNISEARCH_RESULT_TYPES.gate,
      schoolId,
      token,
    );

    return {
      initialValues: {
      },
      edit: false,
      fetchPuertas,
    };
  },
  undefined,
)(reduxForm({
  form: 'createGateway',
  onSubmit,
  validate,
})(CreateExitMethodPopupForm));



// WEBPACK FOOTER //
// ./src/scripts/components/CreateExitMethodPopupContent/CreateExitMethodPopupForm/index.jsx